import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { trackEvent } from "@/lib/analytics";
import { COMPANY } from "@/lib/companyInfo";

// Affiliate offer shown contextually after results. Configure the destination
// in .env.production (VITE_AFFILIATE_DATING_URL) once a CPA/affiliate program
// is approved; the callout hides itself until then.
const AFFILIATE_URL = import.meta.env.VITE_AFFILIATE_DATING_URL as string | undefined;
const AFFILIATE_LABEL =
  (import.meta.env.VITE_AFFILIATE_DATING_LABEL as string | undefined) ??
  "See where singles matching your criteria actually are";

const AffiliateCallout = () => {
  if (!AFFILIATE_URL) return null;

  return (
    <Card className="max-w-2xl mx-auto bg-muted/40">
      <CardContent className="pt-6">
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <p className="text-sm text-muted-foreground flex-1">
            The statistics tell you how rare your match is — meeting them is the next
            step. {AFFILIATE_LABEL}.
          </p>
          <Button asChild variant="secondary" size="sm">
            <a
              href={AFFILIATE_URL}
              target="_blank"
              rel="noopener noreferrer sponsored"
              onClick={() => trackEvent("affiliate_clicked", { placement: "post_results" })}
            >
              Learn more
              <ExternalLink className="w-3.5 h-3.5 ml-2" />
            </a>
          </Button>
        </div>
        <p className="text-[11px] text-muted-foreground mt-3">
          Disclosure: this is a sponsored link. It costs you nothing and supports the free calculator.
          {" "}{COMPANY.brandName} is operated by {COMPANY.legalName}.
        </p>
      </CardContent>
    </Card>
  );
};

export default AffiliateCallout;
